import { render } from "./testmethodview.vue?vue&type=template&id=03b33e98"
import script from "./testmethodview.vue?vue&type=script&lang=js"
export * from "./testmethodview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__